<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start" class="mobile-theme-toggle">
      <ion-button fill="clear" (click)="toggleTheme()" [attr.aria-label]="'SETUP.THEME' | translate">
        <ion-icon [name]="darkMode ? 'moon' : 'sunny'"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'LEADERBOARD.TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div *ngIf="loading" class="loading-wrapper">
    <ion-spinner name="crescent"></ion-spinner>
    <p>{{ 'LEADERBOARD.LOADING' | translate }}</p>
  </div>

  <div *ngIf="!loading && entries.length === 0" class="no-data">
    <ion-icon name="bar-chart-outline"></ion-icon>
    <p>{{ 'LEADERBOARD.NO_DATA' | translate }}</p>
  </div>

  <div *ngIf="!loading && entries.length > 0" class="leaderboard-list">
    <div *ngFor="let entry of entries" class="entry-card" [class.top-three]="entry.rank <= 3">
      <div class="rank-badge" [class.gold]="entry.rank === 1" [class.silver]="entry.rank === 2" [class.bronze]="entry.rank === 3">
        {{ rankLabel(entry.rank) }}
      </div>

      <div class="entry-info">
        <div class="username">{{ entry.displayName }}</div>
        <div class="score-line">
          <ion-icon name="star"></ion-icon>
          <span class="score-value">{{ entry.score }}</span>
          <span class="score-label">{{ 'LEADERBOARD.POINTS' | translate }}</span>
        </div>

        <div class="stats-row">
          <div class="stat">
            <ion-icon name="heart" class="stat-icon likes-icon"></ion-icon>
            <span class="stat-value">{{ entry.songLikes }}</span>
            <span class="stat-label">{{ 'LEADERBOARD.SONG_LIKES' | translate }}</span>
          </div>
          <div class="stat">
            <ion-icon name="musical-note" class="stat-icon contrib-icon"></ion-icon>
            <span class="stat-value">{{ entry.songsInOthersPlaylists }}</span>
            <span class="stat-label">{{ 'LEADERBOARD.SONGS_CONTRIBUTED' | translate }}</span>
          </div>
          <div class="stat">
            <ion-icon name="list" class="stat-icon playlist-icon"></ion-icon>
            <span class="stat-value">{{ entry.playlistsWithLikes }}</span>
            <span class="stat-label">{{ 'LEADERBOARD.PLAYLISTS_CREATED' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
